var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-account-cancellation-container"},[_c('mbHeader',{attrs:{"title":_vm.$t('account_cancellation'),"left":true,"lang":true}}),_vm._v(" "),_c('accountCancellation')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f8a37a3","hasScoped":true,"transformToRequire":{"vue-h-zoom":["image","image-full"]},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/mobile/mobileAccountCancellation.vue
// module id = null
// module chunks = 